import { Request } from '../../Servidor/Request';

export class DengueRelatoryRequest {
    private sgepdengue: number;
    private nome: string;

    constructor(sgepdengue: number, nome: string) {
        this.sgepdengue = sgepdengue;
        this.nome = nome;
    }


    /**
     * Getter sgepdengue
     * @return {number}
     */
    public getSgepDengue(): number {
        return this.sgepdengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class DengueRelatoryStructRequest {
    private sgepdengue: number;

    constructor(sgepdengue: number) {
        this.sgepdengue = sgepdengue;
    }


    /**
     * Getter sgepdengue
     * @return {number}
     */
    public getSgepDengue(): number {
        return this.sgepdengue;
    }

}

export class DengueRelatoryStructResponse {
    private sgepdengue: number;
    private nome: string;

    constructor(sgepdengue: number, nome: string) {
        this.sgepdengue = sgepdengue;
        this.nome = nome;
    }


    /**
     * Getter sgepdengue
     * @return {number}
     */
    public getSgepDengue(): number {
        return this.sgepdengue;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class DengueRelatoryInteractor {
    public fetchSave(request: DengueRelatoryRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("relatorio/dengue", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: DengueRelatoryStructRequest): PromiseLike<DengueRelatoryStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("relatorio/dengue/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }

    public assinarPdf(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/assinarPDF", { sgepdengue }).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }

    public baixarPDFFrente(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        let name = 'Relatorio_dengue_frente.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/dengue/visita-frente", { sgepdengue }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
    public baixarPDFVerso(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        let name = 'Relatorio_dengue_verso.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/dengue/visita-verso", { sgepdengue }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
     public baixarPDFResumoSemanalSUS(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        let name = 'Relatorio_resumo_semanal_sus.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/dengue/resumo-semanal-sus", { sgepdengue }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
    public baixarPDFAmostraColetada(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        let name = 'Relatorio_amostra_encontrada.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/dengue/amostra-encontrada", { sgepdengue }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
    public baixarXLSXAmostraColetada(sgepdengue: number): PromiseLike<DengueRelatoryStructResponse> {
        let name = 'Relatorio_amostra_encontrada.xlsx'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/dengue/amostra-encontrada-xlsx", { sgepdengue }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}